import { render, staticRenderFns } from "./VerdictIcon.vue?vue&type=template&id=0f4f36f6&scoped=true&"
import script from "./VerdictIcon.vue?vue&type=script&lang=js&"
export * from "./VerdictIcon.vue?vue&type=script&lang=js&"
import style0 from "./VerdictIcon.vue?vue&type=style&index=0&id=0f4f36f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f36f6",
  null
  
)

export default component.exports